module.exports = __webpack_public_path__ + "static/media/modal.73fc8312.jpg";